import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ExpensesCategoryDto } from './expenses-category.dto';


export class ExpensesCategoryResponse extends GlobalResponseObject{
    data?: ExpensesCategoryDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ExpensesCategoryDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}